import { _ as _sfc_main } from "./VaButton.vue_vue_type_script_lang-c651faa6.mjs";
import { resolveComponent, openBlock, createBlock, resolveDynamicComponent, mergeProps, withCtx, createElementVNode, normalizeClass, renderSlot, normalizeProps, guardReactiveProps, createCommentVNode, createVNode } from "vue";
import { _ as _export_sfc } from "../../../plugin-vue_export-helper-cc2b3d55.mjs";
const VaButton_vue_vue_type_style_index_0_lang = "";
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_va_icon = resolveComponent("va-icon");
  const _component_va_progress_circle = resolveComponent("va-progress-circle");
  return openBlock(), createBlock(resolveDynamicComponent(_ctx.tagComputed), mergeProps({
    ref: "button",
    class: ["va-button", _ctx.computedClass],
    style: typeof _ctx.computedStyle === "object" ? Array.isArray(_ctx.computedStyle) ? [..._ctx.computedStyle, `--va-0-background-color: ${String(_ctx.backgroundColor)};--va-1-background-color-opacity: ${String(_ctx.backgroundColorOpacity)};--va-2-background-mask-color: ${String(_ctx.backgroundMaskColor)};--va-3-background-mask-opacity: ${String(_ctx.backgroundMaskOpacity)}`] : { ..._ctx.computedStyle, "--va-0-background-color": String(_ctx.backgroundColor), "--va-1-background-color-opacity": String(_ctx.backgroundColorOpacity), "--va-2-background-mask-color": String(_ctx.backgroundMaskColor), "--va-3-background-mask-opacity": String(_ctx.backgroundMaskOpacity) } : _ctx.computedStyle + `;--va-0-background-color: ${String(_ctx.backgroundColor)};--va-1-background-color-opacity: ${String(_ctx.backgroundColorOpacity)};--va-2-background-mask-color: ${String(_ctx.backgroundMaskColor)};--va-3-background-mask-opacity: ${String(_ctx.backgroundMaskOpacity)}`
  }, _ctx.attributesComputed), {
    default: withCtx(() => [
      createElementVNode("span", {
        class: normalizeClass(["va-button__content", _ctx.wrapperClassComputed])
      }, [
        renderSlot(_ctx.$slots, "prepend", normalizeProps(guardReactiveProps({ icon: _ctx.icon, iconAttributes: _ctx.iconAttributesComputed })), () => [
          _ctx.icon ? (openBlock(), createBlock(_component_va_icon, mergeProps({
            key: 0,
            class: "va-button__left-icon",
            name: _ctx.icon
          }, _ctx.iconAttributesComputed), null, 16, ["name"])) : createCommentVNode("", true)
        ]),
        renderSlot(_ctx.$slots, "default"),
        renderSlot(_ctx.$slots, "append", normalizeProps(guardReactiveProps({ icon: _ctx.iconRight, iconAttributes: _ctx.iconAttributesComputed })), () => [
          _ctx.iconRight ? (openBlock(), createBlock(_component_va_icon, mergeProps({
            key: 0,
            class: "va-button__right-icon",
            name: _ctx.iconRight
          }, _ctx.iconAttributesComputed), null, 16, ["name"])) : createCommentVNode("", true)
        ])
      ], 2),
      _ctx.loading ? renderSlot(_ctx.$slots, "loading", normalizeProps(mergeProps({ key: 0 }, {
        size: _ctx.loaderSizeComputed,
        color: _ctx.textColorComputed
      })), () => [
        createVNode(_component_va_progress_circle, {
          class: "va-button__loader",
          size: _ctx.loaderSizeComputed,
          color: _ctx.textColorComputed,
          thickness: 0.15,
          indeterminate: ""
        }, null, 8, ["size", "color", "thickness"])
      ]) : createCommentVNode("", true)
    ]),
    _: 3
  }, 16, ["class", "style"]);
}
const _VaButton = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);
export {
  _VaButton as _
};

import '../../../VaButton.css';
//# sourceMappingURL=VaButton-ff9e16df.mjs.map
